import { render, staticRenderFns } from "./KegiatanLaboratorium.vue?vue&type=template&id=40188df0"
import script from "./KegiatanLaboratorium.vue?vue&type=script&lang=js"
export * from "./KegiatanLaboratorium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40188df0')) {
      api.createRecord('40188df0', component.options)
    } else {
      api.reload('40188df0', component.options)
    }
    module.hot.accept("./KegiatanLaboratorium.vue?vue&type=template&id=40188df0", function () {
      api.rerender('40188df0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanLaboratorium.vue"
export default component.exports